module.exports = __webpack_public_path__ + "static/media/ENGLong1w1042@2x.5caffe9f.jpg";